import { render, staticRenderFns } from "./stockTable.vue?vue&type=template&id=50a558ae&scoped=true"
import script from "./stockTable.vue?vue&type=script&lang=js"
export * from "./stockTable.vue?vue&type=script&lang=js"
import style0 from "./stockTable.vue?vue&type=style&index=0&id=50a558ae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a558ae",
  null
  
)

export default component.exports